(function($) {

// Hide Header on on scroll down
var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = $('header.site-header').outerHeight();
if ($('.mtsnb-absolute').length) {
    navbarHeight = $('.mtsnb-absolute').outerHeight();
}

$(window).scroll(function(event){
    didScroll = true;
});

setInterval(function() {
    if (didScroll) {
        hasScrolled();
        didScroll = false;
    }
}, 250);

function hasScrolled() {
    var st = $(this).scrollTop();
//console.log(st);
    // Make sure they scroll more than delta
    if(Math.abs(lastScrollTop - st) <= delta){
        return;
    }

    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > navbarHeight){
        // Scroll Down
        //console.log( 'Scroll Down: ' + st + ' > ' + lastScrollTop + ' && ' + st + ' > ' + navbarHeight );
        $('header.site-header').removeClass('nav-down').addClass('nav-up');
    } else {
        // Scroll Up
        //console.log( 'SCroll Up: '+ st + ' + ' + $(window).height() + ' < ' + $(document).height() );
        if(st + $(window).height() < $(document).height() ) {
            if ($('.mtsnb-shown').length && st < $('.mtsnb').outerHeight(false)) {
                if ($('body').hasClass('admin-bar')) {
                    $('header.site-header').css('top',$('.mtsnb').outerHeight(false)+32);
                } else {
                    $('header.site-header').css('top',$('.mtsnb').outerHeight(false));
                }
            } else {
                $('header.site-header').css('top','');
            }
            $('header.site-header').removeClass('nav-up').addClass('nav-down');
            if( st < 150 ){
                $('header.site-header').removeClass('nav-down');
            }
        }
    }

    /*if( st > 300 && !$('header.site-header').hasClass('border') ){
        $('header.site-header').addClass('border');
    }
    else{
        $('header.site-header').removeClass('border');
    }*/

    lastScrollTop = st;
}

})(jQuery);
